<template>
  <div class="md-split">
    <div v-for="row in rows" :key="row.label" class="md-split__row">
      <div class="md-split__top">
        <span class="md-split__label">{{ row.label }}</span>
        <span class="md-split__value">{{ row.formatted }}</span>
      </div>
      <div class="md-split__track">
        <div class="md-split__fill" :style="{ width: row.pct + '%', background: row.color }"></div>
      </div>
      <span class="md-split__pct">{{ row.pct }}%</span>
    </div>
  </div>
</template>

<script>
import { fullEuro } from '@/components/mobile/mdFormat';

export default {
  name: 'MdSplitBar',
  props: {
    // [{ label, value (number), color }]
    parts: { type: Array, required: true },
  },
  computed: {
    rows() {
      const total = this.parts.reduce((sum, p) => sum + Math.max(p.value || 0, 0), 0);
      return this.parts.map(p => {
        const value = Math.max(p.value || 0, 0);
        return {
          label: p.label,
          formatted: fullEuro(p.value || 0),
          pct: total > 0 ? Math.round((value / total) * 100) : 0,
          color: p.color,
        };
      });
    },
  },
};
</script>

<style scoped>
.md-split {
  background: var(--md-card-bg, #fff);
  border: 1px solid var(--md-card-border, rgba(34, 41, 47, 0.08));
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(34, 41, 47, 0.06), 0 5px 12px rgba(34, 41, 47, 0.1);
  padding: 0.8rem 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.dark-layout .md-split {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.28), 0 7px 16px rgba(0, 0, 0, 0.22);
}
.md-split__top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 4px;
}
.md-split__label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--md-strong, #24292f);
}
.md-split__value {
  font-size: 13.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--md-strong, #24292f);
}
.md-split__track {
  height: 6px;
  border-radius: 999px;
  background: rgba(138, 145, 156, 0.14);
  overflow: hidden;
}
.md-split__fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.4s ease;
}
.md-split__pct {
  display: block;
  margin-top: 3px;
  font-size: 10.5px;
  font-weight: 600;
  color: var(--md-muted, #8a919c);
}

.dark-layout .md-split {
  --md-card-bg: #283046;
  --md-card-border: #3b4253;
  --md-strong: #d0d2d6;
}
</style>
